import { fromIum } from './fromIum';
import { toIum } from './toIum';
import { expandAndFilter } from './utilities/expand/expandAndFilter';
export class FileCollection {
    constructor(options = {}) {
        this.options = options;
        this.files = [];
        this.sources = [];
    }
    async appendFileList(fileList) {
        for (const file of fileList) {
            const source = {
                name: file.name,
                size: file.size,
                baseURL: 'ium:/',
                //@ts-expect-error We allow file.path as alternative to webkitRelativePath
                relativePath: file.webkitRelativePath || file.path || file.name,
                lastModified: file.lastModified,
                text: () => file.text(),
                arrayBuffer: () => file.arrayBuffer(),
                stream: () => file.stream(),
            };
            this.sources.push(source);
            this.files.push(...(await expandAndFilter(source)));
        }
    }
    async appendText(relativePath, text, options = {}) {
        const source = getSourceFromText(relativePath, text, options);
        this.sources.push(source);
        this.files.push(...(await expandAndFilter(source)));
        return source;
    }
    async appendArrayBuffer(relativePath, arrayBuffer, options = {}) {
        const source = getSourceFromArrayBuffer(relativePath, arrayBuffer, options);
        this.sources.push(source);
        this.files.push(...(await expandAndFilter(source)));
        return source;
    }
    toIum() {
        return toIum(this);
    }
    static fromIum(ium) {
        return fromIum(ium);
    }
    [Symbol.iterator]() {
        return this.files.values();
    }
}
function getSourceFromText(relativePath, text, options = {}) {
    const url = new URL(relativePath, 'ium:/');
    return {
        relativePath: url.pathname,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: async () => {
            return text;
        },
        arrayBuffer: async () => {
            const encoder = new TextEncoder();
            const data = encoder.encode(await text);
            return data.buffer;
        },
    };
}
function getSourceFromArrayBuffer(relativePath, arrayBuffer, options = {}) {
    return {
        relativePath,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: async () => {
            const decoder = new TextDecoder();
            arrayBuffer = await arrayBuffer;
            if (arrayBuffer instanceof Uint8Array) {
                arrayBuffer = arrayBuffer.buffer;
            }
            const text = decoder.decode(arrayBuffer);
            return text;
        },
        arrayBuffer: async () => {
            arrayBuffer = await arrayBuffer;
            if (arrayBuffer instanceof Uint8Array) {
                arrayBuffer = arrayBuffer.buffer;
            }
            return arrayBuffer;
        },
    };
}
//# sourceMappingURL=FileCollection.js.map